import {
  IntegrationsPage,
  IntegrationsProps,
} from "~/pages/integrations/IntegrationsPage";

const AddIntegrationsEntryPage = ({ scope }: IntegrationsProps) => {
  return <IntegrationsPage scope={scope} />;
};

export default AddIntegrationsEntryPage;
